<div class="card mb-4">
  <div class="item_container">
    <div class="d-flex justify-content-between">
      <div>
        <p class="card-title cut_text m-0" style="font-weight: 500;">{{filial.name}}</p>
        <p class="card-title cut_text small m-0" style="font-weight: 300;">{{filial.createdAt | date: 'dd/MM/yyyy HH:mm:ss'}}</p>
      </div>
      <div *ngIf="currentUser.role.name !== 'filialAdmin'" class="dropdown d-flex justify-content-end">
        <i class='bx bx-dots-vertical-rounded' style="font-size: 1.5rem; padding: 5px; cursor: pointer;"
          id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"></i>
        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
          <li><a [routerLink]="detailsRouterLink" class="dropdown-item" translate>filials.details</a></li>
          <li><a [routerLink]="editRouterLink" class="dropdown-item" translate>global.edit</a></li>
          <li><button class="dropdown-item" (click)="onDelete(filial)" translate>global.delete<i class="fa fa-trash ms-2"></i></button></li>
        </ul>
      </div>
    </div>

    <div class="my-4">
      <p class="gray_text" translate>filials.filialDetails</p>
      <div>
        <span>
          <i class='bx bx-home light_blue me-2'></i>
        </span>
        <span class="small">{{filial.address || '/'}}</span>
      </div>

      <div>
        <span>
          <i class='bx bxs-phone light_blue me-2'></i>
        </span>
        <span class="small">{{filial.phone || '/'}}</span>
      </div>
    </div>

  </div>


  <!-- <ul class="list-group list-group-flush">
    <li class="list-group-item cut_text" translate [translateParams]="{value: filial?.address || '/'}"><span><i
          class='bx bxs-city me-2 light_blue'></i></span>filials.address</li>
    <li class="list-group-item" translate [translateParams]="{value: filial?.phone || '/'}"><span><i
          class='bx bxs-phone me-2 light_blue'></i></span>filials.phone</li>
    <li class="list-group-item" style="font-size: .9rem;">{{filial.createdAt | date: 'dd/MM/yyyy HH:mm:ss'}}</li>
  </ul> -->
  <div class="d-flex justify-content-between">
    <div class="button_container">
      <a [routerLink]="detailsRouterLink" class="custom_button" translate>filials.details</a>
    </div>
    <div class="button_container">
      <a [routerLink]="adminsRouterLink" class="custom_button" translate>companies.admins</a>
    </div>
  </div>
</div>